import type { FilterListHeaderProps } from './WalletDetailsFilter.types';
import type { PropsWithChildren, ReactElement } from 'react';

import { Button, Flex, Heading, TextField } from '@rango-dev/whale';
import { Search } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SEARCH_ICON_SIZE = 16;

export function WalletDetailFilterHeader(
  props: PropsWithChildren<FilterListHeaderProps>,
): ReactElement {
  const {
    title,
    handleToggleAll,
    excludedItems,
    searchedFor,
    searchHandler,
    searchInputId,
    toggleButtonId,
    showHeader,
    children,
  } = props;
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap="3">
      {showHeader && (
        <Flex align="center" justify="between" gap="2" py="1">
          <Heading size="2">{title}</Heading>
          <Button
            id={toggleButtonId}
            size="1"
            variant="ghost"
            color="gray"
            radius="full"
            onClick={() => handleToggleAll()}
          >
            {excludedItems?.length === 0 ? t('Deselect all') : t('Select all')}
          </Button>
        </Flex>
      )}
      <Flex direction="column" gap="2">
        <TextField.Root
          id={searchInputId}
          size="2"
          value={searchedFor}
          placeholder={t('Search') || 'Search'}
          onChange={(e) => searchHandler(e.target.value)}
        >
          <TextField.Slot>
            <Search size={SEARCH_ICON_SIZE} />
          </TextField.Slot>
        </TextField.Root>
        {children}
      </Flex>
    </Flex>
  );
}
